var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStickerGxgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 178 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.6782 25.0485H6.52971V8.69637H18.1472V18.503H13.039V15.6156H15.2673V11.5838H9.40959V22.161H21.7984V4.8351H2.87988V25.0485H0V1.94904H24.6782V25.0485Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.2362 27.2553L33.5532 15.0727L33.4797 12.5467L42.3193 0L45.7502 2.42915L37.8193 13.6843L44.6755 22.3097L48.8695 15.6238L44.6143 15.962L44.2823 11.7638L52.7084 11.0942L54.6523 14.313L46.6548 27.063L43.2362 27.2553Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M87.2315 27.2553L96.9132 15.0727L96.9867 12.5467L88.1471 0L84.7176 2.42915L92.6471 13.6843L85.7909 22.3097L81.5969 15.6238L85.8521 15.962L86.1841 11.7638L77.758 11.0942L75.8154 14.313L83.8116 27.063L87.2315 27.2553Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.4018 0.141698L57.6086 1.94836L69.5282 27.1054L73.3214 25.2987L61.4018 0.141698Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M69.5435 0.110934L57.0708 25.2698L60.8313 27.1439L73.304 1.98501L69.5435 0.110934Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M104.108 10.4059L100.641 13.8817L104.108 17.3576L107.575 13.8817L104.108 10.4059Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M120.047 26.9034H105.444L116.298 11.1842L108.845 4.47368L111.545 1.45941L121.647 10.5541L113.154 22.8526H120.047V26.9034Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M134.405 14.282L132.262 12.1332L130.119 14.282L132.262 16.4308L134.405 14.282Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M132.136 26.8584L123.333 14.5244L132.05 1.50574L141.216 13.9352L132.136 26.8584ZM128.025 14.4221L132.119 20.3388L136.474 13.9338L132.205 8.52995L128.025 14.4221Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M155.819 26.9034H141.216L152.07 11.1842L144.617 4.47368L147.317 1.45941L157.419 10.5541L148.926 22.8526H155.819V26.9034Z",
    fill: "var(--fill-0, #FDFAFB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M172.266 28L159.105 19.9024L168.178 0.362793L171.84 2.07179L167.195 12.0762L178 14.8899L172.265 27.9986L172.266 28ZM164.288 18.338L170.428 22.116L172.397 17.6164L165.462 15.8106L164.288 18.338Z",
    fill: "var(--fill-0, #FDFAFB)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerGxgLogo);
export default __webpack_public_path__ + "static/media/sticker-gxg-logo.c9caf00f17242000cea051e61f4d5c72.svg";
export { ForwardRef as ReactComponent };